const table = 'feature-flags';
const environment = process.env.REACT_APP_ENV || "prod";
export const API_ENDPOINT = process.env.REACT_APP_API_URL;

export const ReadAll = async () => {
  const response = await fetch(`${API_ENDPOINT}/${table}?filters[environment][$eq]=${environment}`);

  return await response.json();
};
